<template>
  <div class="relative -top-3 cursor-auto">
    <div
      class="cta-upgrade tooltip-audio-upgrade-now"
      v-click-outside="clickOutsideUpgrade"
    >
      <span>
        <p class="mt-2 whitespace-normal mb-0 text-left">
          ✨ Any editors can host
          <b>{{ planLimit | formatNumber }}</b> <i class="fas fa-user ml-1"></i> <br>(same as your
          <span class="capitalize">{{ $store.state.plan.group }}</span> plan)
        </p>
        <!-- <img src="@/assets/images/presenting-right.svg" alt=""> -->
      </span>

      <img
        src="@/assets/images/close-gray.svg"
        alt=""
        class="absolute top-2 right-2 cursor-pointer"
        @click="clickOutsideUpgrade()"
      >
    </div>
    <div class="upgrade-arrow upgrade-arrow_slide"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Util from '@/util'

export default {
  components: {
  },
  props: {
  },
  computed: {
    ...mapGetters(['planLimit']),
  },
  methods: {
    clickOutsideUpgrade() {
      this.$emit('hide')
      Util.mixpanelTracking(
        'Presentation Editor',
        'Presenting right > Feature onboarding pop-up > Close',
        null,
        null,
        {
          presentationId: this.$store.state.presentation.id,
          userId: this.$store.state.currentUser.id,
          plan: this.$store.state.currentUser.plan,
        },
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.cta-upgrade {
  @apply bg-secondary-100 absolute p-3 rounded z-50;
  left: -134px;
  top: 1.5rem;
  font-family: 'Nunito', sans-serif;
  padding-bottom: 12px;
  text-align: left;
  width: 256px;
  padding-top: 8px;
  padding-left: 16px;

  p {
    line-height: 25px;
  }
  div,
  span {
    @apply text-base-0 text-sm;
  }

  div {
    @apply font-bold;
  }

  span {
    @apply font-normal mt-1;
  }
}

.upgrade-arrow {
  width: 0;
  height: 0;
  border-width: 0 8px 8px 8px;
  border-color: transparent transparent rgba(40, 46, 62, var(--tw-bg-opacity)) transparent;
  border-style: solid;
  position: absolute;
  z-index: 1;
  top: 1.1rem;

  &.upgrade-arrow_presentation {
    left: calc(50% - 47px);
  }

  &.upgrade-arrow_slide {
    left: calc(50% - 8px);
  }
}

.tooltip-audio-upgrade-now {
  .button-upgrade-now {
    margin-top: 12px;
  }
}
</style>
